// Libs
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// Services
import { ApiServiceV2 } from 'services';
// Context
import { ModalBuilderContext } from 'core/context';
// Hooks
import useOrderApi from 'core/hooks/useCoreApi';
// Components
import { Wrapper, Modal, LogoIcon } from 'components';
// ResumePaycutComponents
import { HeaderSettings, ResumeBody } from './Components';
// Selectors
import { selectProfile } from 'screens/Login/selectors';
// Actions
import { sendToast } from 'screens/Dashboard/actions';
// Utils
import { formatData } from 'utils/libs/dateFormats';
import { coinsUtils, xlsx } from 'utils/libs';

const formatResumePaycutData = (resumenPaycut = {}, profile) => {
	const timezone = profile?.organization?.tz;
	const dateFormat = profile?.user?.settings?.date_format;

	return {
		...resumenPaycut,
		paycuts: Array.isArray(resumenPaycut.paycuts)
			? resumenPaycut.paycuts.map(paycut => ({
					...paycut,
					signed:
						Array.isArray(paycut.signed) &&
						paycut.signed.map(sign => ({
							...formatData({ ...sign }, timezone, dateFormat),
							paycut_id: paycut.id,
						})),
			  }))
			: [],
		pays: Array.isArray(resumenPaycut.pays)
			? resumenPaycut.pays.map(pay =>
					formatData({ ...pay }, timezone, dateFormat),
			  )
			: [],
	};
};

const ResumePaycut = () => {
	const { payload: modalPayload, cleanModal } = useContext(ModalBuilderContext);
	const { paycutIds, refreshMainData, isInvoice = false } = modalPayload;
	const profile = useSelector(selectProfile);
	const { getCoinsData } = useOrderApi();

	const [mainState, _setMainState] = useState({
		isLoading: false,
		isRefreshResumen: false,

		excludePayrollUsers: false,
		isInvoice,

		paycut: {},
		resumenPaycut: {},
	});

	const setMainState = newState =>
		_setMainState(current => ({ ...current, ...newState }));

	const handdleCatchError = err => {
		sendToast({ message: err.message, type: err.type });
		setMainState({ isRefreshResumen: false, isLoading: false });
	};

	const getPaycut = () => {
		ApiServiceV2.post({
			url: `/paycuts/getPaycuts`,
			data: {
				type: isInvoice ? 'invoice' : 'payment',
				paycutId: paycutIds[0],
				last_row_id: 0,
				limit: 1,
			},
		})
			.then(paycuts => {
				setMainState({ paycut: paycuts[0] || {}, isRefreshResumen: false });
			})
			.catch(handdleCatchError);
	};

	const handleExportExcel = () => {
		const pays = mainState.resumenPaycut.pays;
		if (!pays?.length) return;
		getCoinsData().then(coinsData => {
			const coinSymbol = coinsUtils.getDataByCoinId(
				mainState.paycut.coin_id,
				'symbol',
				coinsData,
			);
			xlsx.exportPaycutResumeToExcel('Resumen', pays, coinSymbol || '', profile);
		});
	};

	const getResumePaycuts = () => {
		setMainState({ isRefreshResumen: true });

		ApiServiceV2.post({
			url: `/paycuts/resume`,
			data: {
				paycutIds,
				excludePayrollUsers: mainState.excludePayrollUsers,
				isInvoice: mainState.isInvoice,
			},
		})
			.then(resumenPaycut => {
				setMainState({
					resumenPaycut: formatResumePaycutData(resumenPaycut, profile),
					isRefreshResumen: false,
				});
			})
			.catch(handdleCatchError);
	};

	useEffect(() => {
		getPaycut();
		getResumePaycuts();
	}, []);

	return (
		<Modal
			title={null}
			closable={false}
			centered={false}
			visible={true}
			onCancel={cleanModal}
			footer={null}
		>
			<Wrapper
				highBackground
				width='100%'
				padding='10px'
				margin='0'
				flexDirection='column'
				alignItems='center'
				justifyContent='flex-start'
			>
				{mainState.isLoading ? (
					<LogoIcon spin />
				) : (
					<>
						<HeaderSettings
							paymentId={paycutIds[0]}
							isPdfGenered={mainState.paycut.pdf_generated}
							paymentState={mainState.paycut.state}
							setMainState={setMainState}
							getResumePaycuts={getResumePaycuts}
							isRefreshResumen={mainState.isRefreshResumen}
							onExportExcel={handleExportExcel}
							paysLoaded={!!mainState.resumenPaycut.pays?.length}
						/>
						<ResumeBody
							paycut={mainState.paycut}
							pays={mainState.resumenPaycut.pays}
							paycuts={mainState.resumenPaycut.paycuts}
							coinId={mainState.paycut.coin_id}
							cleanModal={cleanModal}
							refreshMainData={refreshMainData}
							paycutIds={paycutIds}
						/>
					</>
				)}
			</Wrapper>
		</Modal>
	);
};

export default ResumePaycut;
